// extracted by mini-css-extract-plugin
export default {"bold":"a2jE8","medium":"b2jE8"};